'use strict';

import moment from 'moment-timezone';
import store from '@/store';

export default {
  filterFn(value, applyUserTimeZone, showLongDate) {
    let formattedValue = '';

    let dateUserFormat = '';
    if (showLongDate) {
      dateUserFormat = 'MM/D/YY ';
    }

    if (value) {
      const { timeZoneUtcOffset, timeFormat } = store.getters['SETTINGS/applicationSettings'];
      const dateTimeFormat = dateUserFormat + timeFormat;

      const time = moment(value, timeFormat, true);
      // Time only
      if (time.isValid()) {
        formattedValue = time.format(dateTimeFormat);
      } else if (applyUserTimeZone) {
        formattedValue = moment(value)
          .utcOffset(timeZoneUtcOffset)
          .format(dateTimeFormat);
      } else {
        formattedValue = moment(value).format(dateTimeFormat);
      }
    }

    return formattedValue;
  }
};
